import styled, { DefaultTheme } from 'styled-components'
import { theme } from '~/styles'

type TextVariants = 'info' | 'error' | 'success' | 'warning'

interface ContainerProps {
  type: TextVariants
}

const getColors = (type: ContainerProps['type'], theme: DefaultTheme) => {
  const text: Record<TextVariants, string> = {
    info: theme.zds.colors.blue200,
    error: theme.zds.colors.red300,
    success: theme.colors.color198754,
    warning: theme.zds.colors.yellow200
  }

  return text[type]
}

const getBackground = (type: ContainerProps['type'], theme: DefaultTheme) => {
  const background: Record<TextVariants, string> = {
    info: theme.zds.colors.blue700,
    error: theme.zds.colors.red700,
    success: theme.colors.colord4edda,
    warning: theme.zds.colors.yellow700
  }

  return background[type]
}

export const Container = styled.div<ContainerProps>`
  color: ${({ type, theme }) => getColors(type, theme)};
  text-align: justify;
  font: normal normal normal 14px/17px Inter;
  background-color: ${({ type, theme }) => getBackground(type, theme)};
  border: 1px solid transparent;
  border-radius: 0.25rem;
  padding: 8px;
`
